'use client'

import { useState } from 'react'

import Swal from 'sweetalert2'

import { inputClassName, buttonClassName } from '@/features/auth/constants/styles'
import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { Button } from '@/shared/ui/Button'

export function ResendConfirmationForm() {
  const { currentEmail, httpClient, isLoading, setIsLoading, goToSignIn } =
    useAuthContext()
  const [email, setEmail] = useState(currentEmail ?? '')

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (isLoading) return

    setIsLoading(true)
    try {
      await httpClient.post('/auth/resend-confirmation', { email })
      await Swal.fire({
        icon: 'success',
        title: 'E-mail de confirmação reenviado!',
        text: 'Verifique sua caixa de entrada e siga as instruções para confirmar sua conta.'
      })
      goToSignIn()
    } catch (error: any) {
      await Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro',
        text:
          error?.message ||
          'Não foi possível reenviar o e-mail de confirmação. Tente novamente mais tarde.'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <div className="grid gap-2">
        <label className="text-sm font-medium">E-mail</label>
        <input
          type="email"
          value={email}
          onChange={event => setEmail(event.target.value)}
          className={inputClassName}
        />
      </div>

      <Button
        type="submit"
        variant="primary"
        disabled={isLoading}
        loading={isLoading}
        className={buttonClassName}
      >
        {isLoading ? 'Solicitando...' : 'Solicitar'}
      </Button>
    </form>
  )
}
